import React from "react";
import { Media, Texts, Title, Button } from "../../Object";
import { Grid, Space } from "../../Layout";
import Nav from "./Nav";
import { Link } from "react-router-dom";

const Footer = () => {
  const args = {
    nav: {
      remove: [],
      position: "footer",
    },
  };
  const googleMap = `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3249.950731714127!2d134.8716440272061!3d35.456014142310444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5fffe7d20636d125%3A0xbc9776e9601789e5!2z44CSNjY4LTAyNTYg5YW15bqr55yM6LGK5bKh5biC5Ye655-z55S65bCP5Lq6!5e0!3m2!1sja!2sjp!4v1684920070926!5m2!1sja!2sjp" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;

  return (
    <>
      <FixContact />
      <Space size={['160px', '80px']}></Space>
      <footer className="l-footer__wrap">
        <div className="l-row l-row--normal">
          <div className="l-footer__wrap--inner">
            <div>
              <Logo />
              <Space size={["40px 0 0", "24px 0 0"]}>
                <Texts
                  slug="footer/address"
                  class="c-text--white c-text--bold"
                ></Texts>
              </Space>
            </div>

            <div>
              <Nav {...args.nav}></Nav>
              <Space size={["64px 0 0", "48px 0 0"]}>
                <Texts
                  slug="footer/copy"
                  class="c-text--white c-text--end"
                ></Texts>
              </Space>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

const Logo = () => {
  return (
    <Link to="/">
      <Media
        src="common/icon-logo"
        alt="icon-logo"
        class="l-footer__img--logo"
        state="footer"
      ></Media>
    </Link>
  );
};

const FixContact = () => {
  return (
    <div className="l-footer__wrap--fix">
      <Link to="tel:0789209791">
        <Media
          src="common/fix-call"
          class="l-footer__wrap--fix__media"
          alt="0789209791"
        ></Media>
      </Link>
      <Link to="/contact">
        <Media
          state="mail"
          src="common/fix-mail"
          class="l-footer__wrap--fix__media"
          alt="お問い合わせフォーム"
        ></Media>
      </Link>
    </div>
  );
};

export const Banner = () => {
  return (
    <>
      <Space size={["216px 0 0", "160px 0 0"]}>
        <div className="l-footer__wrap--banner">
          <div className="l-footer__inner--banner">
            <Title slug="contact" type="white-center"></Title>
            <Space size={["32px 0 48px", "24px 0 32px"]}>
              <Texts
                class="c-text--white c-text--center c-text--bold"
                slug="contact-banner/contact-body"
              ></Texts>
            </Space>
            <ContactButtons></ContactButtons>
          </div>
          <div className="l-footer__inner--banner" data-state="right">
            <Title slug="about-banner" type="white-center"></Title>
            <Space size={["32px 0 48px", "24px 0 32px"]}>
              <Texts
                class="c-text--white c-text--center c-text--bold"
                slug="contact-banner/about-body"
              ></Texts>
            </Space>
            <AboutButton />
          </div>
        </div>
      </Space>
    </>
  );
};

export const AboutButton = () => {
  return (
    <>
      <Space size={["0 auto"]}>
        <Button link="/about/" slug="about" type="line-white"></Button>
      </Space>
    </>
  );
};

export const ContactButtons = () => {
  return (
    <>
      <div className="c-grid__wrap--button">
        <div className="c-grid__wrap--button__inner">
          <Button slug="contact" link="/contact/" type="accent"></Button>
        </div>
        <div className="c-grid__wrap--button__inner">
          <Button slug="number" link="tel:0649677434" type="white"></Button>
          <Texts
            slug="contact/time"
            class="c-text--white c-text--bold c-text--center"
          ></Texts>
        </div>
      </div>
    </>
  );
};

export default Footer;
